export enum ResultType {
    EXACT = 'EXACT',
    SIMILAR = 'SIMILAR',
}
